module.exports = __webpack_public_path__ + "media/images/icons/SVG/046-832e39cb0ca5c825bde4ea3d5e0f1889.svg";